import { WIDGET_CONTROL_TYPE } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Preset for testing square root functions.
 * Focus: Half-parabola shape with tangent line.
 */
export const SQRT_PRESET: GraphpadWidgetConfig = {
  id: 'sqrt',
  type: 'graphpad',
  params: {
    f: {
      type: 'sqrt',
      params: { a: 1, h: 0, k: 0 },
    },
    'f-translate': {
      type: 'handle',
      params: { of: 'f', behavior: 'translate' },
    },
    'f-tangent': {
      type: 'tangent',
      params: { of: 'f', x: 1 },
    },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -2, xEnd: 10, yStart: -2, yEnd: 5 },
      grid: { type: 'lines', visible: false },
    },
    elements: {
      'f-tangent': {
        subparts: {
          touchPoint: {
            point: {
              color: 'green',
              fixed: false,
              label: { position: 'top', text: 'Drag me!' },
            },
          },
          tangentLine: { line: { color: 'green' } },
        },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-a',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'a (scale)',
        param: 'f.a',
        range: [-3, 3, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'amber',
      },
      {
        id: 'slider-h',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'h (x-shift)',
        param: 'f.h',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'green',
      },
      {
        id: 'slider-k',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'k (y-shift)',
        param: 'f.k',
        range: [-3, 3, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'indigo',
      },
    ],
  },
};
